import { render, staticRenderFns } from "./wikiNodeEdit.vue?vue&type=template&id=60d5091c&"
import script from "./wikiNodeEdit.vue?vue&type=script&lang=ts&"
export * from "./wikiNodeEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports